"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ctrl = 'f6 link dim br2 ba bw1 ph3 pv2 mv2 mr1 dib b--light-gray bg-white light-red';
const fctrl = 'f5 link dim bn dib mid-gray bg-transparent light-red';
exports.default = {
    ctrl,
    fctrl,
};
